import React from 'react';

const PricingForm = ({
  showForm,
  setShowForm,
  editingId,
  formData,
  onInputChange,
  onSubmit,
  onReset,
  saving,
}) => (
  <>
    <div className="flex justify-between items-center mb-4">
      <h2 className="font-display text-2xl font-bold text-heading">
        {showForm ? (editingId ? 'Edit Pricing' : 'Add Pricing') : 'Pricing Configuration'}
      </h2>
      {!showForm && (
        <button
          onClick={() => setShowForm(true)}
          className="btn-clay-accent flex items-center"
        >
          <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Add Pricing
        </button>
      )}
    </div>

    {showForm && (
      <div className="card-clay p-6 mb-6">
        <form onSubmit={onSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-body-text mb-1">Provider</label>
              <select
                name="provider"
                value={formData.provider}
                onChange={onInputChange}
                required
                className="w-full px-3 py-2 border-2 border-clay-border rounded-clay bg-surface text-body-text placeholder-[color:var(--color-text-tertiary)] focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              >
                <option value="">Select provider</option>
                <option value="openai">OpenAI</option>
                <option value="gemini">Gemini</option>
                <option value="anthropic">Anthropic</option>
                <option value="vertex_ai">Vertex AI</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-body-text mb-1">Model</label>
              <input
                type="text"
                name="model"
                value={formData.model}
                onChange={onInputChange}
                required
                placeholder="e.g., gpt-4o-mini"
                className="w-full px-3 py-2 border-2 border-clay-border rounded-clay bg-surface text-body-text placeholder-[color:var(--color-text-tertiary)] focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-body-text mb-1">Effective From</label>
              <input
                type="date"
                name="effective_from"
                value={formData.effective_from}
                onChange={onInputChange}
                required
                className="w-full px-3 py-2 border-2 border-clay-border rounded-clay bg-surface text-body-text placeholder-[color:var(--color-text-tertiary)] focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-body-text mb-1">Input Cost per 1M Tokens ($)</label>
              <input
                type="number"
                name="input_cost_per_1m"
                value={formData.input_cost_per_1m}
                onChange={onInputChange}
                step="0.000001"
                min="0"
                placeholder="e.g., 0.15"
                className="w-full px-3 py-2 border-2 border-clay-border rounded-clay bg-surface text-body-text placeholder-[color:var(--color-text-tertiary)] focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-body-text mb-1">Output Cost per 1M Tokens ($)</label>
              <input
                type="number"
                name="output_cost_per_1m"
                value={formData.output_cost_per_1m}
                onChange={onInputChange}
                step="0.000001"
                min="0"
                placeholder="e.g., 0.60"
                className="w-full px-3 py-2 border-2 border-clay-border rounded-clay bg-surface text-body-text placeholder-[color:var(--color-text-tertiary)] focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-body-text mb-1">Per Request Cost ($)</label>
              <input
                type="number"
                name="per_request_cost"
                value={formData.per_request_cost}
                onChange={onInputChange}
                step="0.000001"
                min="0"
                placeholder="For non-token pricing"
                className="w-full px-3 py-2 border-2 border-clay-border rounded-clay bg-surface text-body-text placeholder-[color:var(--color-text-tertiary)] focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
          </div>
          <div className="mt-4 flex space-x-3">
            <button
              type="submit"
              disabled={saving}
              className="btn-clay-accent disabled:opacity-50"
            >
              {saving ? 'Saving...' : (editingId ? 'Update' : 'Create')}
            </button>
            <button
              type="button"
              onClick={onReset}
              className="btn-clay"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    )}
  </>
);

export default PricingForm;
